import { atom, Path } from '@cloudio-saas/statex';
import { ExpressionValue } from 'componentregistry';
import { ExpressionReturnType } from 'layout/Sidebar/panels/PropertiesView/property-editors/types';

export const categoryFilterAtom = atom({
  path: ['transient', 'category', 'filter'],
  defaultValue: '',
});

export const categorySelectedAtom = atom({
  path: ['transient', 'category', 'selected'],
  defaultValue: 'Boolean',
});

export interface ExpressionProps {
  returnType: ExpressionReturnType;
  open: boolean;
  path: Path;
  type: 'string' | 'expressionObject';
  value: ExpressionValue;
  context: {
    appUid: string;
    pageId: string;
    itemId: string;
    property: string;
    data: Record<string, unknown>;
  };
}

export const expressionPropsAtom = atom<ExpressionProps>({
  path: ['transient', 'expression', 'open'],
  defaultValue: {
    open: false,
    returnType: 'string',
    path: [],
    type: 'expressionObject',
    value: { type: 'expression', value: '' },
    context: {
      appUid: '',
      pageId: '',
      itemId: '',
      property: '',
      data: {},
    },
  },
});

export const selectedFunctionAtom = atom({
  path: ['transient', 'expression', 'selectedFunction'],
  defaultValue: 'concat',
});
